






import { defineComponent } from "@vue/composition-api";
import { PurchasedFileOwner } from "@scrile/api-provider/dist/api/PurchasedFileProvider";
import PurchasesCreator from "../PurchasesCreator/PurchasesCreator.vue";

export default defineComponent({
  name: "PurchasesCreatorList",
  components: { PurchasesCreator },
  props: {
    items: { type: Array as () => PurchasedFileOwner[], default: () => [] },
  },
});
